import * as React from 'react';
export const duplicateSvg = React.forwardRef(function duplicateSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M9.75 0a2 2 0 0 1 2 2v5.5a2 2 0 0 1-2 2h-1v.5a2 2 0 0 1-2 2h-4.5a2 2 0 0 1-2-2V4c0-.69.56-1.25 1.25-1.25a.747.747 0 0 1 .25 1.454V10a.5.5 0 0 0 .5.5h4.5a.5.5 0 0 0 .5-.5v-.5h-2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h4.5Zm-4.5 1.5a.5.5 0 0 0-.5.5v5.5a.5.5 0 0 0 .5.5h4.5a.5.5 0 0 0 .5-.5V2a.5.5 0 0 0-.5-.5h-4.5Z',
    }),
  );
});
duplicateSvg.defaultProps = {
  width: '12',
  height: '12',
  viewBox: '0 0 12 12',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var duplicate = {
  category: 'icon',
  colorable: true,
  name: 'duplicate',
  svg: duplicateSvg,
};
